import * as Yup from 'yup';
//utils
import {phoneSchema} from '@/utils/validation';

export type PhoneFormValues = {
	number: string;
};

export const initialValues: PhoneFormValues = {
	number: '',
};

export const validationSchema = Yup.object().shape({
	number: phoneSchema.required('Phone number is required'),
});
